// extracted by mini-css-extract-plugin
module.exports = {"empty_deck_msg":"emptyDeckMsg_empty_deck_msg__13yM7","escondido":"emptyDeckMsg_escondido__2FN0c"};